import React from 'react';
import { Typography } from '@mui/material';
import SupplierTable from '../tables/SupplierTable';

const SupplierSection = () => {
  return (
    <>
      <Typography marginRight={1} marginTop={2} variant='h3'>
        Suppliers
      </Typography>
      <SupplierTable />
    </>
  );
};

export default SupplierSection;
